import {DomainObject, oneOf} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import _ from 'lodash';

class MFAUser extends DomainObject {
  cellphone = '';
  countryCode = '1';
  mfaToken;
  mfaType;
  mfaParameter;

  _relations = {
    mfaType: oneOf(['sms', 'authenticator'])
  };

  constructor(other) {
    super();

    makeObservable(this, {
      cellphone: observable,
      countryCode: observable,
      mfaToken: observable,
      mfaType: observable,
      mfaParameter: observable
    });

    this.merge(other);
  }

  toJS() {
    const json = super.toJS();
    json['mfaPhoneNumber'] = `+${json['countryCode']}${json['cellphone']}`;

    return _.omit(json, ['cellphone', 'countryCode']);
  }
}

export default MFAUser;
